<h1 mat-dialog-title>Review Judges</h1>
<div mat-dialog-content>
    <p>
        Please review the list of judges to be imported.
        The columns with (user) in the header are what was typed in the spreadsheet by the user and the regular column is what the computer interpreted it as.
        Any errors in reading the spreadsheet will be highlighted in red and all valid judges will be colored green.
        Any existing judges for this same award, district, phase, and school year will be indicated in the duplicate column by the words 'Database'.
        Any judges within this spreadsheet with the same values will be indicated in the duplicate column by the words 'Spreadsheet'.
        Click 'Confirm' to add all non-duplicate and valid judges to the system or click 'Cancel' to go back and fix any errors.
    </p>
    <div>
        <table>
            <thead>
                <tr>
                    <th>Duplicate</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>District</th>
                    <th>District (user)</th>
                    <th>Nomination</th>
                    <th>Nomination (user)</th>
                    <th>Phase</th>
                    <th>Phase (user)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let j of AllJudges" [class.success]="ValidJudge(j)">
                    <td [class.error]="j.Duplicate"><span *ngIf="j.Duplicate"><span *ngIf="j.DbDuplicate">Database</span><span *ngIf="!j.DbDuplicate">Spreadsheet</span></span></td>
                    <td [class.error]="j.Errors[0] || j.Errors[1]">{{j.FirstName}} {{j.LastName}}</td>
                    <td [class.error]="j.Errors[2]">{{j.Email}}</td>
                    <td>{{j.DistrictNumber}}</td>
                    <td [class.error]="j.Errors[3]">{{j.DistrictUser}}</td>
                    <td>{{j.NomineeTypeName}}</td>
                    <td [class.error]="j.Errors[4]">{{j.NomineeTypeUser}}</td>
                    <td>{{j.PhaseName}}</td>
                    <td [class.error]="j.Errors[5]">{{j.PhaseUser}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button type="button" [color]="'accent'" (click)="CancelHandler()">Cancel</button>
    <button mat-raised-button type="button" [color]="'primary'"(click)="OkHandler()">Confirm</button>
</div>